import {Modal} from './Modal';
import {PhoneNumberInput} from './PhoneNumberInput';
import {InfinityPager} from './InfinityPager';
import {Signature} from './Signature';

const map = {
  Modal,
  PhoneNumberInput,
  InfinityPager,
  Signature,
};

export default map;
